import React from 'react';
import { PhoneForwarded, CalendarDays, Clock, BarChart3, ChevronRight } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface TodaysOverviewProps {
  hasData: boolean;
  onNavigate?: (screen: string) => void;
}
export function TodaysOverview({
  hasData,
  onNavigate
}: TodaysOverviewProps) {
  const {
    isLight
  } = useTheme();
  const minutesUsed = 34;
  const minutesTotal = 100;
  return <div className="space-y-3" data-id="element-255">
      <h3 className={`text-sm font-bold uppercase tracking-wider ${isLight ? 'text-slate-500' : 'text-zinc-500'}`} data-id="element-256">
        Today's Overview
      </h3>
      {hasData ? <div className="space-y-3" data-id="element-257">
          {/* Calls & Meetings row */}
          <div className="grid grid-cols-2 gap-3" data-id="element-258">
            <button onClick={() => onNavigate?.('calls')} className={`flex items-center gap-3 p-3.5 rounded-2xl transition-colors text-left ${isLight ? 'bg-white/70 border border-slate-100 active:bg-slate-50' : 'bg-white/[0.03] border border-white/5 active:bg-white/[0.06]'}`} data-id="element-259">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${isLight ? 'text-blue-500 bg-blue-50' : 'text-blue-400 bg-blue-500/10'}`} data-id="element-260">
                <PhoneForwarded className="w-5 h-5" data-id="element-261" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-262">
                <span className={`text-xl font-bold block leading-tight ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-263">
                  12
                </span>
                <span className={`text-[11px] font-medium ${isLight ? 'text-slate-500' : 'text-zinc-500'}`} data-id="element-264">
                  Calls Handled
                </span>
              </div>
              <ChevronRight className={`w-3.5 h-3.5 flex-shrink-0 ${isLight ? 'text-slate-300' : 'text-zinc-600'}`} data-id="element-265" />
            </button>

            <button onClick={() => onNavigate?.('calendar')} className={`flex items-center gap-3 p-3.5 rounded-2xl transition-colors text-left ${isLight ? 'bg-white/70 border border-slate-100 active:bg-slate-50' : 'bg-white/[0.03] border border-white/5 active:bg-white/[0.06]'}`} data-id="element-266">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${isLight ? 'text-purple-500 bg-purple-50' : 'text-purple-400 bg-purple-500/10'}`} data-id="element-267">
                <CalendarDays className="w-5 h-5" data-id="element-268" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-269">
                <span className={`text-xl font-bold block leading-tight ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-270">
                  4
                </span>
                <span className={`text-[11px] font-medium ${isLight ? 'text-slate-500' : 'text-zinc-500'}`} data-id="element-271">
                  Meetings Booked
                </span>
              </div>
              <ChevronRight className={`w-3.5 h-3.5 flex-shrink-0 ${isLight ? 'text-slate-300' : 'text-zinc-600'}`} data-id="element-272" />
            </button>
          </div>

          {/* Minutes Used — full width with progress bar */}
          <button onClick={() => onNavigate?.('profile')} className={`w-full p-4 rounded-2xl transition-colors text-left ${isLight ? 'bg-white/70 border border-slate-100 active:bg-slate-50' : 'bg-white/[0.03] border border-white/5 active:bg-white/[0.06]'}`} data-id="element-273">
            <div className="flex items-center justify-between mb-2.5" data-id="element-274">
              <div className="flex items-center gap-2.5" data-id="element-275">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${isLight ? 'text-amber-500 bg-amber-50' : 'text-amber-400 bg-amber-500/10'}`} data-id="element-276">
                  <Clock className="w-4.5 h-4.5" data-id="element-277" />
                </div>
                <div data-id="element-278">
                  <span className={`text-sm font-bold block leading-tight ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-279">
                    Minutes Used
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-280">
                <span className={`text-sm font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-281">
                  {minutesUsed}
                </span>
                <span className={`text-xs ${isLight ? 'text-slate-400' : 'text-zinc-500'}`} data-id="element-282">
                  / {minutesTotal} min
                </span>
                <ChevronRight className={`w-3.5 h-3.5 ml-1 ${isLight ? 'text-slate-300' : 'text-zinc-600'}`} data-id="element-283" />
              </div>
            </div>
            <div className={`h-2 rounded-full overflow-hidden ${isLight ? 'bg-slate-100' : 'bg-white/10'}`} data-id="element-284">
              <div className="h-full rounded-full bg-amber-500 transition-all duration-500" style={{
            width: `${minutesUsed / minutesTotal * 100}%`
          }} data-id="element-285" />
            </div>
          </button>
        </div> : <div className={`rounded-2xl p-6 flex flex-col items-center text-center ${isLight ? 'bg-white/70 border border-slate-100' : 'bg-white/[0.03] border border-white/5'}`} data-id="element-286">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-3 ${isLight ? 'bg-slate-100' : 'bg-white/5'}`} data-id="element-287">
            <BarChart3 className={`w-6 h-6 ${isLight ? 'text-slate-300' : 'text-zinc-600'}`} data-id="element-288" />
          </div>
          <p className={`text-sm font-semibold mb-1 ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-289">
            No activity yet
          </p>
          <p className={`text-xs leading-relaxed max-w-[220px] ${isLight ? 'text-slate-400' : 'text-zinc-500'}`} data-id="element-290">
            Once Vexu.ai starts handling calls, your stats will appear here.
          </p>
        </div>}
    </div>;
}